import { render } from "./UserPasswordDialog.vue?vue&type=template&id=3f6e5324&scoped=true"
import script from "./UserPasswordDialog.vue?vue&type=script&lang=js"
export * from "./UserPasswordDialog.vue?vue&type=script&lang=js"

import "./UserPasswordDialog.vue?vue&type=style&index=0&id=3f6e5324&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6e5324"]])

export default __exports__